import {
    IExtendedReportingObject,
    IInitialState,
    IIntersectionData,
    TAvailableReportingObjectsType,
    TRawPaiwiseIntersectionsData,
    TRawPercentAverageIntersectionsData,
} from './interfaces';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../../../../../../store';

const initialState: IInitialState = {
    rawPecentAverageIntersections: null,
    extendedReportingObjectsById: null,
    rawPaiwiseIntersections: null,
    intersectionsDataById: null,
    isLoading: false,
    daysInPeriod: 0,
    isError: false,
    selectedReportingObjectsType: 'tenant',
    dataRefetchObject: {},
};

const Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer = createSlice({
    name: 'Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer',
    initialState,
    reducers: {
        /**
         * Сохранение расширенной информации о выбранных отчтеных объектах
         */
        storeExtendedReportingObjectsById: (
            state,
            action: PayloadAction<null | { [id: string]: IExtendedReportingObject }>,
        ) => {
            state.extendedReportingObjectsById = action.payload;
        },

        /**
         * Изменение флага загрузки
         */
        toggleLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },

        /**
         * Изменение флага ошибки
         */
        toggleError: (state, action: PayloadAction<boolean>) => {
            state.isError = action.payload;
        },

        /**
         * Сохранение сырых данных по пересечениям в процентах
         */
        storeRawPercentAverageIntersections: (state, action: PayloadAction<TRawPercentAverageIntersectionsData>) => {
            state.rawPecentAverageIntersections = action.payload;
        },

        /**
         * Сохранение сырых данных по пересеченяим не в процентах
         */
        storeRawPaiwiseIntersections: (state, action: PayloadAction<TRawPaiwiseIntersectionsData>) => {
            state.rawPaiwiseIntersections = action.payload;
        },

        /**
         * Сохранение значений метрики пересечений
         */
        storeIntersectionsDataById: (
            state,
            action: PayloadAction<{ [mainId: string]: { [contraId: string]: IIntersectionData } } | null>,
        ) => {
            state.intersectionsDataById = action.payload;
        },

        /**
         * Сохранение количество дней в периоде
         */
        storeDaysInPeriod: (state, action: PayloadAction<number>) => {
            state.daysInPeriod = action.payload;
        },

        /**
         * запись выбранного типа отчетных объектов
         */
        storeSelectedReportingObjectsType: (state, action: PayloadAction<TAvailableReportingObjectsType>) => {
            state.selectedReportingObjectsType = action.payload;
        },

        /**
         * Перезагрузка виджета
         */
        reloadWidget: (state) => {
            state.dataRefetchObject = {};
        },

        /**
         * Обнуление редьюсера
         */
        resetReducer: () => initialState,
    },
});

export const {
    storeExtendedReportingObjectsById,
    toggleLoading,
    toggleError,
    storeRawPercentAverageIntersections,
    storeRawPaiwiseIntersections,
    storeIntersectionsDataById,
    storeDaysInPeriod,
    resetReducer,
    storeSelectedReportingObjectsType,
    reloadWidget,
} = Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer.actions;

export const Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer_Values = (state: RootState) =>
    state.Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer;

export default Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer.reducer;
